import { render, staticRenderFns } from "./VerifyEmailError.vue?vue&type=template&id=4c8a98c8&scoped=true&"
import script from "./VerifyEmailError.vue?vue&type=script&lang=js&"
export * from "./VerifyEmailError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8a98c8",
  null
  
)

export default component.exports